import useUserDetails from "@ch/helpers/hooks/useUserDetails";
import { AuthRoutesEnum } from "@ch/router/AuthRoutes/enums";
import type { FC, ReactNode } from "react";
import { Navigate } from "react-router-dom";

interface LoggedInRouteProps {
  children: ReactNode;
}

const LoggedInRoute: FC<LoggedInRouteProps> = ({ children }) => {
  const { isLoggedIn } = useUserDetails();

  if (!isLoggedIn) {
    return <Navigate replace to={AuthRoutesEnum.LOGIN} />;
  }

  return children;
};

export default LoggedInRoute;
